export const initialState = {};

export default (state = initialState) => state;
